import uuid from 'uuid/v1'
export class AssignmentStatusDto{
    public UniqueID: string
    public Name:string 
    public IsCompleted : boolean = false
    public IsActive : boolean = false
    public Color : string 
}